import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const NAMES = ['María L.', 'Sofía G.', 'Carla R.', 'Lucía P.', 'Florencia M.', 'Camila D.', 'Valentina S.', 'Agustina F.', 'Brenda T.', 'Daniela C.', 'Romina V.', 'Mariana B.', 'Julieta N.', 'Pilar A.', 'Micaela O.', 'Andrea H.', 'Gabriela E.', 'Noelia I.', 'Ximena K.', 'Rocío Z.', 'Belén U.', 'Antonella J.', 'Paula Q.', 'Verónica W.'];
const PROVINCES = ['Buenos Aires', 'CABA', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Chaco', 'Corrientes', 'Misiones', 'Santiago del Estero', 'San Juan', 'Jujuy', 'Río Negro', 'Neuquén', 'Formosa', 'Chubut', 'San Luis', 'Catamarca', 'La Rioja', 'La Pampa', 'Santa Cruz', 'Tierra del Fuego'];
const PACKS = [{
  label: 'Megapack',
  emoji: '📘'
}, {
  label: 'Megapack + Embajadora',
  emoji: '🏆'
}];
const TIMES = ['hace 2 min', 'hace 4 min', 'hace 6 min', 'hace 8 min', 'hace 11 min', 'hace 14 min'];
function randomPurchase() {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const province = PROVINCES[Math.floor(Math.random() * PROVINCES.length)];
  const pack = PACKS[Math.floor(Math.random() * PACKS.length)];
  const time = TIMES[Math.floor(Math.random() * TIMES.length)];
  return {
    name,
    province,
    pack,
    time
  };
}
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<ReturnType<typeof randomPurchase> | null>(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // First popup after 8s, then every 15s
    const firstTimeout = setTimeout(() => {
      setPurchase(randomPurchase());
      setVisible(true);
    }, 8000);
    const interval = setInterval(() => {
      setVisible(false);
      // Show new one after a short fade-out
      setTimeout(() => {
        setPurchase(randomPurchase());
        setVisible(true);
      }, 600);
    }, 15000);
    // Auto-hide each popup after 6s
    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);
  // Auto-hide after 6s of being visible
  useEffect(() => {
    if (!visible) return;
    const hide = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(hide);
  }, [visible, purchase]);
  if (dismissed) return null;
  return <AnimatePresence data-id="element-280">
      {visible && purchase && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-40 max-w-[280px] md:max-w-xs bg-white rounded-xl shadow-2xl border border-brand-choco/10 overflow-hidden" role="status" aria-live="polite" data-id="element-281">
          <div className="flex items-start gap-3 p-3" data-id="element-282">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-gold/15 flex items-center justify-center text-lg" data-id="element-283">
              {purchase.pack.emoji}
            </div>
            <div className="flex-1 min-w-0 pr-4" data-id="element-284">
              <p className="text-[12px] md:text-sm text-brand-choco-deep leading-snug" data-id="element-285">
                <span className="font-bold" data-id="element-286">{purchase.name}</span>{' '}
                <span className="text-brand-choco/70" data-id="element-287">de</span>{' '}
                <span className="font-semibold" data-id="element-288">{purchase.province}</span>
              </p>
              <p className="text-[11px] md:text-xs text-brand-choco/70 mt-0.5 leading-snug" data-id="element-289">
                acaba de comprar el{' '}
                <span className="font-semibold text-brand-choco-deep" data-id="element-290">
                  {purchase.pack.label}
                </span>
              </p>
              <div className="flex items-center gap-1 mt-1" data-id="element-291">
                <CheckCircleIcon className="text-green-600" style={{
              fontSize: 12
            }} data-id="element-292" />
                <span className="text-[10px] md:text-[11px] text-brand-choco/60" data-id="element-293">
                  Compra verificada · {purchase.time}
                </span>
              </div>
            </div>
            <button type="button" aria-label="Cerrar notificación" onClick={() => setDismissed(true)} className="absolute top-1.5 right-1.5 text-brand-choco/40 hover:text-brand-choco transition-colors" data-id="element-294">
              <CloseIcon style={{
            fontSize: 16
          }} data-id="element-295" />
            </button>
          </div>
          {/* Progress bar */}
          <div className="h-0.5 bg-brand-gold/20 overflow-hidden" data-id="element-296">
            <motion.div key={purchase.name + purchase.province} initial={{
          width: '100%'
        }} animate={{
          width: '0%'
        }} transition={{
          duration: 6,
          ease: 'linear'
        }} className="h-full bg-brand-gold" data-id="element-297" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}